import React, {useState} from 'react';
import {Input, message, Modal} from "antd";
import ImgClose from "@/shared/pictures/close.svg";
import ImgSecret from "@/shared/pictures/secret.png";
import {useStore} from "@/app/providers/StoreProvider";
import {ModalPayload} from "@/entities/modals/types";
import {IQuestItemType} from "@/entities/quest/types";


export const QuestInputModal = (payload: ModalPayload<"questInput">) => {
    const { modalStore, questsStore, errorStore } = useStore();

    const [codeWord, setCodeWord] = useState('');

    const sendCode = async () => {
        if(!codeWord){
            message.error('Пароль не может быть пустым');
            return;
        }
        const check = await questsStore.checkQuests({questNameEnum:payload.id,secret:codeWord});
        await questsStore.getQuests();
        modalStore.open('questCompleted',{});
        // if(check){
        //
        // }else {
        //     modalStore.open('questDeclined',{});
        // }

    }

    return (
        <Modal
            open={true}
            footer={null}
            closeIcon={<img src={ImgClose} onClick={() => modalStore.close()} alt=""/>}
        >
            <div className='modal'>

                <img src={ImgSecret} className='modal_image'
                     alt="" style={{maxWidth: 100}}/>

                <h3 className='modal_title'>Введите секретный пароль</h3>

                <Input placeholder="Введите пароль"
                    value={codeWord}
                    onChange={(e) => setCodeWord(e.target.value)}
                />

                <div className='modal_buttons'>
                    <button type='button' className='modal_button button_blue'
                            onClick={() => sendCode()}>Проверить
                    </button>
                    <button type='button' className='modal_button button_gray'
                            onClick={() => modalStore.close()}>Закрыть
                    </button>
                </div>

            </div>
        </Modal>
    );
};

